import archivoBoldUrl from '@fontsource/archivo/files/archivo-latin-700-normal.woff2?url';

const PRELOAD_SELECTOR = 'link[data-powerhive-critical-font]';

/**
 * Start the one display face in the authenticated shell before Svelte mounts.
 * The remaining faces are fetched on demand by their font-face rules, keeping
 * initial transfer bounded while retaining the visual hierarchy of the shell.
 */
export function preloadCriticalFont(): void {
  if (typeof document === 'undefined' || document.querySelector(PRELOAD_SELECTOR)) return;

  const link = document.createElement('link');
  link.dataset.powerhiveCriticalFont = '';
  link.rel = 'preload';
  link.as = 'font';
  link.type = 'font/woff2';
  link.crossOrigin = 'anonymous';
  link.href = archivoBoldUrl;
  document.head.append(link);
}
